<template>
  <div class="payment-card">
    <form method="post" action="https://prepro.adquiracloud.mx/clb/endpoint/poderJudicialAgs" class="payment-form">
      <h2>Datos de pago</h2>

      <div class="field">
        <label for="mp_account">ID Cliente</label>
        <input id="mp_account" name="mp_account" v-model="form.mp_account" />
      </div>

      <div class="field">
        <label for="mp_order">Orden</label>
        <input id="mp_order" name="mp_order" v-model="form.mp_order" />
      </div>

      <div class="field">
        <label for="mp_reference">Referencia</label>
        <input id="mp_reference" name="mp_reference" v-model="form.mp_reference" />
      </div>

      <div class="field">
        <label for="mp_product">ID Producto</label>
        <input id="mp_product" name="mp_product" v-model="form.mp_product" />
      </div>

      <div class="field">
        <label for="mp_node">Nodo</label>
        <input id="mp_node" name="mp_node" v-model="form.mp_node" />
      </div>

      <div class="field">
        <label for="mp_concept">Concepto</label>
        <input id="mp_concept" name="mp_concept" v-model="form.mp_concept" />
      </div>

      <div class="field">
        <label for="mp_amount">Importe</label>
        <input id="mp_amount" name="mp_amount" v-model="form.mp_amount" />
      </div>

      <div class="field">
        <label for="mp_currency">Moneda</label>
        <input id="mp_currency" name="mp_currency" v-model="form.mp_currency" />
      </div>

      <div class="field">
        <label for="mp_urlsuccess">URL Pago exitoso</label>
        <input id="mp_urlsuccess" name="mp_urlsuccess" v-model="form.mp_urlsuccess" />
      </div>

      <div class="field">
        <label for="mp_urlfailure">URL Pago no exitoso</label>
        <input id="mp_urlfailure" name="mp_urlfailure" v-model="form.mp_urlfailure" />
      </div>

      <button type="submit" class="btn-submit">Pagar</button>
    </form>
  </div>
</template>

<script>
export default {
    name: 'MultipagosTest',
    data() {
        return {
            form: {
                mp_account: 17068,
                mp_order: 1,
                mp_reference: 'ABCDEF123456',
                mp_product: 1,
                mp_node: 1,
                mp_concept: 1,
                mp_amount: 100.00,
                mp_currency: 1,
                mp_urlsuccess: 'https://www.poderjudicialags.gob.mx/MultipagosSuccess',
                mp_urlfailure: 'https://www.poderjudicialags.gob.mx/MultipagosFailed'
            }
        }
    },
}
</script>

<style scoped>
.payment-card {
  max-width: 460px;
  margin: 32px auto;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.payment-form {
  padding: 20px 24px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
}

.payment-form h2 {
  margin: 0 0 16px;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
}

.field {
  margin-bottom: 10px;
}

.field label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #6b6b6b;
  margin-bottom: 3px;
}

.field input {
  width: 100%;
  padding: 5px 8px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fafafa;
  color: #1a1a1a;
  font-size: 12px;
  box-sizing: border-box;
  transition: background 0.1s ease, border-color 0.1s ease;
}

.field input:hover {
  background: #f0f0f0;
}

.field input:focus {
  outline: none;
  background: #fff;
  border-color: #333;
}

.btn-submit {
  margin-top: 6px;
  padding: 6px 14px;
  border: none;
  border-radius: 3px;
  background: #1a1a1a;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.btn-submit:hover {
  background: #333;
}
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/Multipagos/MultipagosTest.vue